import { SpeedInsights } from '@vercel/speed-insights/next';

import { parseFloatWithFallback } from '@pflegia/util/common/parse-float-with-fallback';

const MIN_SAMPLE_RATE = 0;
const MAX_SAMPLE_RATE = 1;
const DEFAULT_SAMPLE_RATE = 0.5;

const SAMPLE_RATE = parseFloatWithFallback(process.env.NEXT_PUBLIC_SPEED_INSIGHTS_SAMPLE_RATE, DEFAULT_SAMPLE_RATE, {
  min: MIN_SAMPLE_RATE,
  max: MAX_SAMPLE_RATE,
});

const VercelSpeedInsights: React.FC = () => <SpeedInsights sampleRate={SAMPLE_RATE} />;

export default VercelSpeedInsights;
